import React from 'react'
import { connect } from 'react-redux'
import { debounce, get } from 'lodash'
import moment from 'moment'

import {
  fetchReservations,
  deleteReservation,
  confirmReservation,
} from '../../actions/fetch_reservation'
import { WarningReservationTable } from './ReservationTable'
import { createQueryFilter } from './createQueryFilter'
import DateRangeSelector from '../commons/DateRangeSelector'
import { createDateRangeQuery } from '../../utils/dateRangeUtils'

class WarningReservationTableContainer extends React.Component {
  abortController = null

  state = {
    selectionMode: 'day', // 'day' or 'month'
    selectedDate: moment(),
    year: moment().year(),
    month: moment().month(),
    filter: null,
  }

  componentDidMount() {
    this.handleDataChange = debounce(this.handleDataChange, 1000)
  }

  componentWillUnmount() {
    this.abortInFlights()
  }

  abortInFlights() {
    if (this.abortController) {
      this.abortController.abort()
      this.abortController = undefined
    }
  }

  handleSelectionModeChange = (mode) => {
    this.setState({ selectionMode: mode }, () => {
      // Trigger data refetch with updated selection mode
      if (this.state.filter) {
        this.handleDataChange(this.state.filter)
      }
    })
  }

  handleDateChange = (date) => {
    this.setState({ selectedDate: date }, () => {
      // Trigger data refetch with updated date
      if (this.state.filter) {
        this.handleDataChange(this.state.filter)
      }
    })
  }

  handleMonthChange = (field, value) => {
    this.setState({ [field]: value }, () => {
      if (this.state.filter) {
        // Use saved filter from state
        this.handleDataChange(this.state.filter)
      }
    })
  }

  handleDataChange = (filter) => {
    // Save filter to state
    this.setState({ filter })

    this.abortInFlights()
    this.abortController = new AbortController()

    const baseQuery = createQueryFilter(filter.query) || {}

    // // Add date range query based on selection mode
    // const dateRangeQuery = createDateRangeQuery(
    //   this.state.selectionMode,
    //   this.state.selectedDate,
    //   this.state.year,
    //   this.state.month,
    // )
    // Object.assign(baseQuery, dateRangeQuery)

    this.props.fetchReservations(
      {
        page: filter.currentPage,
        limit: filter.sizePerPage,
        sort: filter.sort,
        order: filter.order,
        warning: true,
        ...baseQuery,
      },
      {
        fetchId: 'warningReservation',
        signal: this.abortController.signal,
      },
    )
  }

  customCreateButtonGroup = (props) => <div />

  customRenderToolbar = (defaultFilterButton) => {
    return (
      <div className="pull-right flex gap-2 items-center">
        {/* <DateRangeSelector */}
        {/*   selectionMode={this.state.selectionMode} */}
        {/*   selectedDate={this.state.selectedDate} */}
        {/*   year={this.state.year} */}
        {/*   month={this.state.month} */}
        {/*   onSelectionModeChange={this.handleSelectionModeChange} */}
        {/*   onDateChange={this.handleDateChange} */}
        {/*   onMonthChange={this.handleMonthChange} */}
        {/* /> */}
        {defaultFilterButton}
      </div>
    )
  }

  render() {
    return (
      <WarningReservationTable
        {...this.props}
        isJobAssignable={false}
        headerI18nKey="reservationWarningPage.table.header"
        i18nPageKey="reservationPage"
        defaultSortName="serviceDateTime"
        defaultSortOrder="desc"
        bothType={true}
        onDataChange={this.handleDataChange}
        onConfirm={this.handleReservationConfirm}
        options={{ btnGroup: this.customCreateButtonGroup }}
        settings={{ insertRow: false, deleteRow: false, selectRow: undefined }}
        customRenderToolbar={this.customRenderToolbar}
      />
    )
  }
}

export default connect(
  ({ fetch, auth }) => ({
    isLoading: get(fetch, 'warningReservation.isLoading.list', false),
    instances: get(fetch, 'warningReservation.list', []),
    totalCount: get(fetch, 'warningReservation.totalCount'),
    auth,
  }),
  { fetchReservations, deleteInstance: deleteReservation, confirmReservation },
)(WarningReservationTableContainer)
